var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"btnClick",on:{"click":_vm.startTopic}},[_vm._v("开始"),_c('br'),_vm._v("答题")]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("../../../../../assets/image/rule.jpg")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2920b458","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/WeChat/Person/Testing/index.vue
// module id = null
// module chunks = 